<template>
  <ul class="mt-0.5 flex flex-col gap-0.5">
    <li
      v-for="(question, index) in questionsWithData"
      :key="question.id"
      class="bg-surface rounded-extra-small flex flex-row items-center gap-0.5 px-3 py-1.5"
    >
      <span class="text-body-medium grow pr-2">
        {{ question.text }}
      </span>
      <BaseIconButton
        v-if="question.data?.text"
        icon="chat_bubble"
        color="tonalTertiary"
        size="XS"
        class="mr-1"
        @click="openTextFeedback(question)"
      />
      <JournalAnalysisValueBar
        :value="question.data?.value ?? null"
        :transition-delay="index * (300 / feedbacks.length) + 'ms'"
      />
    </li>
  </ul>
  <JournalAnalysisTextFeedbackDialog
    :is-open="isOpen"
    :member="member"
    :question-text="selectedQuestionText"
    :feedback-text="selectedFeedbackText"
    :feedback-value="selectedFeedbackValue"
    @close="closeDialog"
  />
</template>

<script setup lang="ts">
  import { computed, ref } from 'vue'
  import type { JSONContent } from '@tiptap/vue-3'
  import type { MemberOrUser } from '@/core/models/member/member-or-user'
  import BaseIconButton from '../base/button/icon-button/BaseIconButton.vue'
  import JournalAnalysisValueBar from './JournalAnalysisValueBar.vue'
  import JournalAnalysisTextFeedbackDialog from './JournalAnalysisTextFeedbackDialog.vue'
  import { useDialog } from '../base/dialog/use-dialog'

  interface Props {
    member: MemberOrUser
    feedbacks: ReadonlyArray<{
      id: string
      value: number | null
      text: JSON | null
      questionId: string
    }>
    questions: ReadonlyArray<{
      id: string
      text: string
    }>
  }

  const props = defineProps<Props>()

  const selectedFeedbackText = ref<JSONContent | null>(null)
  const selectedFeedbackValue = ref<number | null>(null)
  const selectedQuestionText = ref('')
  const { isOpen, openDialog, closeDialog } = useDialog()

  const questionsWithData = computed(() => {
    return props.questions.map((question) => {
      return {
        ...question,
        data: props.feedbacks.find((feedback) => feedback.questionId === question.id),
      }
    })
  })

  const openTextFeedback = (question: (typeof questionsWithData.value)[number]) => {
    if (!question.data?.text) return
    selectedFeedbackText.value = question.data.text as JSONContent
    selectedFeedbackValue.value = question.data.value
    selectedQuestionText.value = question.text
    openDialog()
  }
</script>
